/* Built In Imports */
/* Internal Imports */
/* External Imports */
import { Box, Flex, Image } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Component */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/* Styles */
/* Services */
/**
 * Renders Banner Component
 * @param {Object} sectionContent - Data for the section
 * @param {string} region - Region for the Section
 * @param {string} lang - Language for the Section
 * @returns  {ReactElement} - Banner Component
 */
const Banner = ({ sectionContent, region, lang }) => {
  // consoleLog('app', sectionContent);
  return (
    <Box>
      {/* Fixed width for the banner */}
      {/* Slanted background starts */}
      <Box maxW={'1300px'} mx={{ base: '0', lg: 'auto', md: '15px' }}>
        <Box
          zIndex={-2}
          background="#f5f0e5"
          pos={'relative'}
          width="100%"
          height={'100%'}
          _before={{
            pos: 'absolute',
            content: '""',
            width: '100%',
            height: '100%',
            background: 'linear-gradient(to bottom, #1c0f08, #351f15 90%)',
            top: '0',
            left: '0',
            zIndex: '-1',
            clipPath: 'polygon(0 0%, 100% 0, 100% 77%, 0% 90%)',
          }}
        >
          {/* Slanted Background Ends*/}
          {/* Content of the page Starts */}
          <Flex
            flexDir={{ base: 'column', md: 'row' }}
            alignItems={{ base: 'center', md: 'normal' }}
            justifyContent={{ base: 'center', md: 'normal' }}
          >
            <Box
              width={{ base: '100%', md: '45%' }}
              paddingTop={{ base: '46px', md: '50px', lg: '113px' }}
              textAlign="center"
              className="content"
            >
              <Flex
                flexDir={'column'}
                alignItems="center"
                justifyContent={'center'}
              >
                <Image
                  width={{ base: '45px', md: '100px', lg: 144 }}
                  src={sectionContent[0]?.image?.url}
                  alt={sectionContent[0]?.image?.alt}
                  title={sectionContent[0]?.image?.title}

                // src="https://isha.sadhguru.org/profiles/isha/themes/ishatheme/sadhguruapp/images/app-image.png"
                />
                <Box
                  width="100%"
                  fontFamily="'FedraSansStd-medium', sans-serif"
                  fontSize={{ base: '18px', md: '28px', lg: '42px' }}
                  color="#ffffff"
                  lineHeight="1.17"
                  textAlign="center"
                >
                  <StructuredTextParser
                    str={render(sectionContent[1].body)}
                    region={region}
                    lang={lang}
                    fontFamily="'FedraSansStd-medium', sans-serif"
                    fontSize={{ base: '18px', md: '28px', lg: '42px' }}
                    color="#ffffff"
                    textAlign="center"
                  />
                  
                </Box>
                <Box
                  as={'p'}
                  width="100%"
                  fontFamily="'FedraSansStd-book', sans-serif"
                  fontSize={{ base: '14px', md: '16px', lg: '22px' }}
                  color="#ffffff"
                  textAlign="center"
                  className="des"
                >
                  {sectionContent[2].text}
                </Box>
                <Box
                  width={{ base: '262px', md: '300px', lg: '412px' }}
                  borderRadius="10px"
                  backgroundColor="#ffffff"
                  padding={{ base: '15px', md: '15px', lg: '24px 20px' }}
                  marginTop="20px"
                  className="ratingBox"
                >
                  <Box
                    className="text"
                    fontFamily="'FedraSansStd-book', sans-serif"
                    fontSize={{ base: '16px', md: '16px', lg: '26px' }}
                    color="#0e0e0e"
                    textAlign="left"
                  >
                    {sectionContent[3].text}
                  </Box>
                  <Box
                    className="rating"
                    fontFamily="'FedraSansStd-medium', sans-serif"
                    fontSize={{ base: '16px', md: '16px', lg: '24px' }}
                    d={{ base: '-webkit-box', md: 'flex' }}
                    color={'#121212'}
                    textAlign={'left'}
                    width={'100%'}
                  >
                    {sectionContent[4].text}
                    <Box mx="5px">
                      <Image
                        src={sectionContent[5].image.url}
                        alt={sectionContent[5].image.alt}
                        title={sectionContent[5].image.title}

                        width={27}
                        objectFit="cover"
                      />
                      <Image
                        src={sectionContent[5].image.url}
                        alt={sectionContent[5].image.alt}
                        title={sectionContent[5].image.title}
                        width={27}
                        objectFit="cover"
                      />{' '}
                      <Image
                        src={sectionContent[5].image.url}
                        alt={sectionContent[5].image.alt}
                        title={sectionContent[5].image.title}
                        width={27}
                        objectFit="cover"
                      />{' '}
                      <Image
                        src={sectionContent[5].image.url}
                        alt={sectionContent[5].image.alt}
                        title={sectionContent[5].image.title}
                        width={27}
                        objectFit="cover"
                      />{' '}
                      <Image
                        src={sectionContent[6].image.url}
                        alt={sectionContent[6].image.alt}
                        title={sectionContent[6].image.title}

                        width={27}
                        objectFit="cover"
                      />
                    </Box>
                  </Box>
                  <Box></Box>
                </Box>
              </Flex>
            </Box>
            <Flex
              alignItems={'center'}
              justifyContent="center"
              width={'55%'}
              pt={{ base: '30px', md: '87px' }}
              className="img"
            >
              <Image
                width={{ base: '209px', md: '300px', lg: '600px' }}
                src={sectionContent[7].image.url}
                alt={sectionContent[7].image.alt}
                title={sectionContent[7].image.title}

              />
            </Flex>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default Banner;
